module.exports = __webpack_public_path__ + "static/media/joy-yellow.b80fb0f4.png";